import Search from "../search/Index"
const SelectCards = () => {
  return (
    <Search type={'mining'}></Search>
  )
}
export default SelectCards